<div [id]="'plotly-plot-'+_id" class="app-plotly-plot"></div>